export const appendScript = (
  src: string,
  id: string,
  callback: Function
): void => {
  const scriptElement = document.createElement('script');
  const tag = document.getElementsByTagName('script')[0];

  scriptElement.src = src;
  scriptElement.type = 'text/javascript';
  scriptElement.async = true;
  scriptElement.id = id;

  scriptElement.onload = () => {
    callback();
  };

  tag?.parentNode?.insertBefore(scriptElement, tag);
};
